import { render, staticRenderFns } from "./SendTestSmsModal.vue?vue&type=template&id=e7d217de&"
import script from "./SendTestSmsModal.vue?vue&type=script&lang=js&"
export * from "./SendTestSmsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7d217de')) {
      api.createRecord('e7d217de', component.options)
    } else {
      api.reload('e7d217de', component.options)
    }
    module.hot.accept("./SendTestSmsModal.vue?vue&type=template&id=e7d217de&", function () {
      api.rerender('e7d217de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SmsSettings/SendTestSmsModal.vue"
export default component.exports